// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
import fetch from 'share/fetch/Izenda.Fetch';
const IMPORT_URL = 'importManagement/';

export default {
  BASE_PATH: IMPORT_URL,
  /**
   * Validate import's content
   * @param {Object} data
   * @returns {promise}
   */
  validateImportContent(data: any): Promise {
    return fetch(`${IMPORT_URL}validate`).post(data);
  },

  /**
   * Upload files
   * @param  {Array} files
   * @return {Promise}
   */
  uploadFiles(files: any) {
    return fetch(`${IMPORT_URL}file`).upload(files);
  },

  /**
   * Get detail file
   * @param {Object} data
   * @returns {promise}
   */
  getDetailFile(data: any) {
    return fetch(`${IMPORT_URL}information`).post(data);
  },

  /**
   * Validate overwrite reports/dashboard
   * @param {Object} data
   * @returns {promise}
   */
  validateOverride(data: any) {
    return fetch(`${IMPORT_URL}validateOverride`).post(data);
  },

  /**
   * Begin import files
   * @param {Object} data
   */
  importFiles(data: any) {
    return fetch(`${IMPORT_URL}import`).post(data);
  },

  /**
   * Cancel import
   * @param {Object} data
   */
  cancelImport(data: any) {
    return fetch(`${IMPORT_URL}cancel`).post(data);
  },

  /**
   * Get import status
   * @param {Array<string>} data
   */
  getImportStatus(data: Array<string>) {
    return fetch(`${IMPORT_URL}status`).post(data);
  },

  /**
   * Get new database mappings
   * @param {Array} data
   */
  getDatabaseMappings(data: Array<string>) {
    return fetch(`${IMPORT_URL}databaseMapping`).post(data);
  },

  /**
   * Remove importing files by their ids.
   * @param {Array<string>} data
   * @returns {Promise} A promise object of invoking REST API result
   */
  removeFiles(data: Array<string>): Promise {
    return fetch(`${IMPORT_URL}removeFiles`).post(data);
  },

  /**
   * Remove importing files by their ids (sync).
   * @param {Array<string>} data
   * @returns {Promise} A promise object of invoking REST API result
   */
  removeFilesSync(data: Array<string>): Promise {
    return fetch(`${IMPORT_URL}removeFiles`).post(data, null, false);
  },

  /**
   * Get import histories
   * @param {Object} data
   * @returns {Promise}
   */
  loadImportHistories(data: any): Promise {
    return fetch(`${IMPORT_URL}loadImportHistories`).post(data);
  },

  /**
   * Delete histories
   * @param {Array<string>} data 
   */
  deleteHistories(data: Array<string>):Promise {
    return fetch(`${IMPORT_URL}deleteHistories`).post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.ImportFetcher.js